import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const projects = [
  { src: "./2.jpg", alt: "Projekt 1", span: "row-span-2" },
  { src: "./3.jpg", alt: "Projekt 2", span: "" },
  { src: "./4.jpg", alt: "Projekt 3", span: "" },
  { src: "./5.jpg", alt: "Projekt 4", span: "" },
  { src: "./7.jpg", alt: "Projekt 5", span: "" },
];

export default function UntersutzeProjekte() {
  const navigate = useNavigate();

  return (
    <div className="py-20 px-6">
      <h2 className="text-3xl md:text-4xl font-bold text-darkBlue text-center mb-10">
        UNTERSTÜTZTE PROJEKTE
      </h2>
      <div className="w-full flex justify-center">
        <div className="w-full max-w-4xl">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
            {projects.map((project, i) => (
              <div
                key={i}
                className={`overflow-hidden rounded-lg ${project.span} group cursor-pointer`}
                onClick={() => navigate("/projekte")}
              >
                <img
                  src={project.src}
                  alt={project.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
            ))}
          </div>
          <div className="text-center mt-8">
            <motion.button
              onClick={() => navigate("/projekte")}
              className="px-8 py-3 bg-darkBlue rounded-lg text-white font-medium hover:bg-blue-800 transition-colors"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Alle Projekte ansehen
            </motion.button>
          </div>
        </div>
      </div>
    </div>
  );
}
